module.exports = __webpack_public_path__ + "media/images/videos/hero-baa100c26abfd215114a50308ebcfa0e.mp4";